export default function getOriginalDateTime(date) {
  const year = date.split("T")[0].split("-")[0];
  const month = date.split("T")[0].split("-")[1] - 1;
  const day = date.split("T")[0].split("-")[2];
  const hour = date.split("T")[1].split(":")[0];
  const minute = date.split("T")[1].split(":")[1];
  return new Date(year, month, day, hour, minute);
}
